// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ReportList_wrapper__3AzJu"};